<div *ngIf="isLoading" class="loader">Loading Images...</div>
<ngx-gallery
  class="ngx-gallery"
  *ngIf="!isLoading"
  [options]="galleryOptions"
  [images]="galleryImagesList"
  #gallery
></ngx-gallery>
